export default "__VITE_ASSET__ac1RcIDY__"